<template>
  <div class="monitoramento">
    <default-header />
    <default-navigation v-on:emit-item="setValue" />
    <v-main>
      <v-divider />
      <v-container>
        <analyze v-if="item == 0" />
        <history v-else-if="item == 1" />
        <home v-else-if="item == 2" />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "monitoramento",
  components: {
    "default-header": () => import("../components/header/index.vue"),
    "default-navigation": () => import("../components/navigation/index.vue"),

    analyze: () => import("../pages/analyze.vue"),
    history: () => import("../pages/history.vue"),
    home: () => import("../pages/home.vue")
  },
  data: () => ({
    item: 0
  }),

  methods: {
    ...mapActions({
      actionLoadAnalyse: "monitoring/actionLoadAnalyze"
    }),
    setValue(value) {
      this.item = value;
    }
  },
  created() {
    this.actionLoadAnalyse();
  }
};
</script>
